/**
 * Generates query string for passed object
 * @param params
 */
export const generateQueryStringFromObject = (params: object): string => (
    Object.keys(params).map((key) => `${key}=${params[key]}`).join('&')
)